import React from "react";
import { TestimonialPage as PageType } from "../../types/quiz";
import '../../assets/scss/quiz-editorial.scss';

interface Props {
  page: PageType;
  onNext: () => void;
}

const TestimonialPage: React.FC<Props> = ({ page, onNext }) => {
  const stars = Array.from({ length: 5 }, (_, i) => i < page.rating);

  return (
    <div className="page page--testimonial">
      <div className="page__container">
        <div className="testimonial-card">
          <div className="testimonial-card__stars">
            {stars.map((filled, i) => (
              <span
                key={i}
                className={`testimonial-card__star ${
                  filled ? "testimonial-card__star--filled" : ""
                }`}
              >
                ★
              </span>
            ))}
          </div>

          <h3 className="testimonial-card__title">{page.title}</h3>
          <p className="testimonial-card__text">{page.text}</p>
          <p className="testimonial-card__author">- {page.author}</p>
        </div>

        <div className="page__actions">
            <button className="page__button page__button--block" onClick={onNext}>
              {page.buttonText}
            </button>
        </div>
      </div>
    </div>
  );
};

export default TestimonialPage;
